export default {
  // Page title
  'messageAdmin.title': 'Message Admin',
  'messageAdmin.add': 'Send Message',

  // Actions
  'messageAdmin.action.details': 'Details',

  // Columns
  'messageAdmin.column.no': '#NO',
  'messageAdmin.column.id': 'ID',
  'messageAdmin.column.taskId': 'TaskId',
  'messageAdmin.column.title': 'Title',
  'messageAdmin.column.typeDesc': 'Type',
  'messageAdmin.column.msgType': 'MsgType',
  'messageAdmin.column.content': 'Content',
  'messageAdmin.column.extend': 'Extend',
  'messageAdmin.column.pushTime': 'SendTime',
  'messageAdmin.column.status': 'Status',
  'messageAdmin.column.operator': 'Operator',
  'messageAdmin.column.createTime': 'CreateTime',
  'messageAdmin.column.modifyTime': 'ModifyTime',
  'messageAdmin.column.action': 'Action',

  // Search
  'messageAdmin.search.taskId': 'TaskId',
  'messageAdmin.search.status': 'Status',

  // Form
  'messageAdmin.form.title': 'Title',
  'messageAdmin.form.msgType': 'MsgType',
  'messageAdmin.form.subtitle': 'Subtitle',
  'messageAdmin.form.content': 'Content',
  'messageAdmin.form.type': 'SendType',
  'messageAdmin.form.type.all': 'All User',
  'messageAdmin.form.type.set': 'Set User',
  'messageAdmin.form.usernoList': 'SendUserNoList',
  'messageAdmin.form.usernoList.placeholder': 'Multiple IDs separated by commas',
  'messageAdmin.form.pushTime': 'SendTime',
};